var $35ddcc5622bd4b85$exports = {};
const $35ddcc5622bd4b85$var$userLang = navigator.language || navigator.userLanguage;
if ($35ddcc5622bd4b85$var$userLang.startsWith("fr")) window.location.href = "fr/index.html";
else window.location.href = "en/index.html";


//# sourceMappingURL=index.e5447a32.js.map
